import { styled, Tooltip, tooltipClasses } from "@mui/material"

const DarkTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ styles = {} }) => {
  const backgroundColor = styles.backgroundColor || "#333645";

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor,
      color: "#FFFFFF",
      fontSize: 13,
      borderRadius: "8px",
      fontWeight: 400,
      fontFamily: "Gilroy",
      padding: "4px 8px",
      marginRight: 15,
      maxWidth: "400px",
      textAlign: "center",
      ...styles,
    },
    [`& .MuiTooltip-arrow`]: {
      color: backgroundColor,
    },
  };
});

export default DarkTooltip
